/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function CustomerImportDtoFromJSON(json) {
    return CustomerImportDtoFromJSONTyped(json, false);
}
export function CustomerImportDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'companyName': !exists(json, 'companyName') ? undefined : json['companyName'],
        'firstName': !exists(json, 'firstName') ? undefined : json['firstName'],
        'lastName': !exists(json, 'lastName') ? undefined : json['lastName'],
        'correspondenceAddressCity': !exists(json, 'correspondenceAddressCity') ? undefined : json['correspondenceAddressCity'],
        'correspondenceAddressPostalCode': !exists(json, 'correspondenceAddressPostalCode') ? undefined : json['correspondenceAddressPostalCode'],
        'correspondenceAddressStreet': !exists(json, 'correspondenceAddressStreet') ? undefined : json['correspondenceAddressStreet'],
        'correspondenceAddressBuildingNumber': !exists(json, 'correspondenceAddressBuildingNumber') ? undefined : json['correspondenceAddressBuildingNumber'],
        'correspondenceAddressApartmentNumber': !exists(json, 'correspondenceAddressApartmentNumber') ? undefined : json['correspondenceAddressApartmentNumber'],
        'billAddressCity': !exists(json, 'billAddressCity') ? undefined : json['billAddressCity'],
        'billAddressPostalCode': !exists(json, 'billAddressPostalCode') ? undefined : json['billAddressPostalCode'],
        'billAddressStreet': !exists(json, 'billAddressStreet') ? undefined : json['billAddressStreet'],
        'billAddressBuildingNumber': !exists(json, 'billAddressBuildingNumber') ? undefined : json['billAddressBuildingNumber'],
        'billAddressApartmentNumber': !exists(json, 'billAddressApartmentNumber') ? undefined : json['billAddressApartmentNumber'],
        'nip': !exists(json, 'nip') ? undefined : json['nip'],
        'regon': !exists(json, 'regon') ? undefined : json['regon'],
        'krs': !exists(json, 'krs') ? undefined : json['krs'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'additionalEmail': !exists(json, 'additionalEmail') ? undefined : json['additionalEmail'],
        'phone': !exists(json, 'phone') ? undefined : json['phone'],
        'phoneNumberPrefix': !exists(json, 'phoneNumberPrefix') ? undefined : json['phoneNumberPrefix'],
        'additionalPhone': !exists(json, 'additionalPhone') ? undefined : json['additionalPhone'],
        'additionalPhoneNumberPrefix': !exists(json, 'additionalPhoneNumberPrefix') ? undefined : json['additionalPhoneNumberPrefix'],
    };
}
export function CustomerImportDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'companyName': value.companyName,
        'firstName': value.firstName,
        'lastName': value.lastName,
        'correspondenceAddressCity': value.correspondenceAddressCity,
        'correspondenceAddressPostalCode': value.correspondenceAddressPostalCode,
        'correspondenceAddressStreet': value.correspondenceAddressStreet,
        'correspondenceAddressBuildingNumber': value.correspondenceAddressBuildingNumber,
        'correspondenceAddressApartmentNumber': value.correspondenceAddressApartmentNumber,
        'billAddressCity': value.billAddressCity,
        'billAddressPostalCode': value.billAddressPostalCode,
        'billAddressStreet': value.billAddressStreet,
        'billAddressBuildingNumber': value.billAddressBuildingNumber,
        'billAddressApartmentNumber': value.billAddressApartmentNumber,
        'nip': value.nip,
        'regon': value.regon,
        'krs': value.krs,
        'email': value.email,
        'additionalEmail': value.additionalEmail,
        'phone': value.phone,
        'phoneNumberPrefix': value.phoneNumberPrefix,
        'additionalPhone': value.additionalPhone,
        'additionalPhoneNumberPrefix': value.additionalPhoneNumberPrefix,
    };
}
